import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { c as _ } from "../clsx-OuTLNxxd.js";
import { PaginationButton as n } from "../PaginationButton/PaginationButton.js";
const v = "SliderControls-module_scrollbar__f7Y8L",
  b = "SliderControls-module_scrollbar-step__vTkfk",
  p = "SliderControls-module_scrollbar-step-active__wAepy",
  S = "SliderControls-module_controls__hz6ZN",
  h = "SliderControls-module_controls-left__G16dW",
  f = "SliderControls-module_buttons__vlVo9",
  C = "SliderControls-module_variant-white__2S64k",
  N = "SliderControls-module_variant-gray__YtJB9",
  y = "SliderControls-module_variant-titanium__psxb3",
  t = {
    scrollbar: v,
    scrollbarStep: b,
    scrollbarStepActive: p,
    controls: S,
    controlsLeft: h,
    buttons: f,
    variantWhite: C,
    variantGray: N,
    variantTitanium: y
  },
  k = {
    goToPage: "Go to page",
    previous: "Previous",
    next: "Next",
    counterSeparator: "of"
  },
  G = _ref => {
    let {
      totalPages: l,
      currentSlideIndex: s,
      isBeginning: i,
      isEnd: c,
      nextSlide: d,
      prevSlide: u,
      labels: a,
      className: m,
      variantColor: r = "neutral05"
    } = _ref;
    return /* @__PURE__ */o("div", {
      className: _(t.controls, m, {
        [t.variantGray]: r == "neutral05",
        [t.variantWhite]: r == "white",
        [t.variantTitanium]: r == "titanium"
      }),
      children: [/* @__PURE__ */o("div", {
        className: t.controlsLeft,
        children: [/* @__PURE__ */o("div", {
          className: t.scrollbar,
          "aria-hidden": !0,
          children: [/* @__PURE__ */e("div", {
            className: t.scrollbarStepActive,
            style: {
              width: "calc(100% / ".concat(l, ")"),
              transform: "translateX(calc(".concat(s, " * 100%))")
            }
          }), /* @__PURE__ */e("div", {
            className: t.scrollbarStep
          })]
        }), /* @__PURE__ */o("div", {
          className: t.totalPageser,
          children: [s + 1, " ", a.counterSeparator, " ", l]
        })]
      }), /* @__PURE__ */e("div", {
        className: "swiper-pagination"
      }), /* @__PURE__ */o("div", {
        className: t.buttons,
        children: [/* @__PURE__ */e(n, {
          dataContentPiece: "slider_previous_button",
          arrow: "left",
          disabled: i,
          onClick: u,
          "aria-label": a.previous,
          role: "button",
          variant: "secondary",
          inverted: r == "titanium"
        }), /* @__PURE__ */e(n, {
          dataContentPiece: "slider_next_button",
          arrow: "right",
          disabled: c,
          onClick: d,
          "aria-label": a.next,
          role: "button",
          variant: "secondary",
          inverted: r == "titanium"
        })]
      })]
    });
  };
export { G as SliderControls, k as defaultLabels };